module.exports = __webpack_public_path__ + "transform_icon.898a28f59bf7c8a4dac1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/transform_icon.svg
// module id = 1411
// module chunks = 3